import { render, staticRenderFns } from "./CropFilterDialog.vue?vue&type=template&id=2a45340f&scoped=true"
import script from "./CropFilterDialog.vue?vue&type=script&lang=js"
export * from "./CropFilterDialog.vue?vue&type=script&lang=js"
import style0 from "./CropFilterDialog.vue?vue&type=style&index=0&id=2a45340f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a45340f",
  null
  
)

export default component.exports